"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePublicSettingsLoader = void 0;
const utils_1 = require("@juvare/common-web-ui/utils");
const hooks_1 = require("../../../../ui/hooks");
const react_redux_1 = require("react-redux");
const getPublicSettings_1 = require("../stores/getPublicSettings");
const publicSettingsSlice_1 = require("../stores/publicSettingsSlice");
function usePublicSettingsLoader(appName) {
    const status = (0, react_redux_1.useSelector)(getPublicSettings_1.getPublicSettingsLoadingStatus);
    const dispatch = (0, react_redux_1.useDispatch)();
    const publicDataClient = (0, hooks_1.usePublicDataClient)(appName);
    return (0, hooks_1.usePreloader)({
        status,
        onLoad: () => {
            dispatch(publicSettingsSlice_1.publicSettingsSlice.actions.setLoading());
            return publicDataClient.publicDataGetObject('public-editable-settings');
        },
        onSuccess: (result) => {
            dispatch(publicSettingsSlice_1.publicSettingsSlice.actions.setSettings(result));
        },
        onError: (error) => {
            dispatch(publicSettingsSlice_1.publicSettingsSlice.actions.setError((0, utils_1.getErrorMessage)(error)));
        },
    });
}
exports.usePublicSettingsLoader = usePublicSettingsLoader;
